/** A cancellable timer that starts again from its full duration on every start. */
export function oneShotClock() {
  let timer: ReturnType<typeof setTimeout> | null = null;
  const stop = (): void => {
    if (timer !== null) clearTimeout(timer);
    timer = null;
  };
  return {
    start(ms: number, then: () => void): void {
      stop();
      timer = setTimeout(() => {
        timer = null;
        then();
      }, ms);
    },
    stop,
    running: (): boolean => timer !== null,
  };
}
